import { render, staticRenderFns } from "./ProductInventorySearchItem.vue?vue&type=template&id=5e06c2a7"
import script from "./ProductInventorySearchItem.vue?vue&type=script&lang=js"
export * from "./ProductInventorySearchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports